module.exports = __webpack_public_path__ + "a60c242d0c4e751817b9a2dd43486d5b.pdf";